import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateRowDecision } from "@services/subscriberSyncUpload";

export function useUpdateSubscriberSyncRow(options: any = {}) {
  const queryClient = useQueryClient();

  return useMutation(updateRowDecision, {
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["subscriberSyncUpload", variables.uploadId],
      });
    },
    ...options,
  });
}
